export default __webpack_public_path__ + "static/media/1.e8b7ee45.jpg";